import { Preferences as Storage } from "@capacitor/preferences";
const environmentVariable = await Storage.get({key: 'environment'});

/**
 * Returns the active environment name, preferring the persisted
 * Preference value over the build-time env variable.
 * This is the single source of truth used by all env helpers.
 */
const getActiveEnv = () => environmentVariable?.value || process.env.VUE_APP_NODE_ENV;

export function environment(variable) {
  
  const STAGING = {
    name: 'staging',
    access: ''
  };
  const PROD = {
    name: 'production',
    access: '_PROD'
  };
  const EU_PROD = {
    name: 'eu_production',
    access: '_EU_PROD'
  };
  
  const env = getActiveEnv();
  switch(env) {
    case STAGING.name: variable += STAGING.access; break;
    case PROD.name: variable += PROD.access; break;
    case EU_PROD.name: variable += EU_PROD.access; break;
    default: break; // Keep variable as-is for development/local
  }

  return process.env[variable];
}

/**
 * Returns true when running against a production environment.
 * Uses the same env resolution as environment() so both helpers stay consistent.
 */
export const isLive = () => getActiveEnv()?.includes('production') ?? false;

/**
 * Returns true when the dashboard is served from the EU region hostname.
 * Replaces the inline `location.hostname.includes(...)` pattern.
 */
export const isEuServer = () => {
  if (typeof location === 'undefined') return false;
  return location.hostname.includes('jumperdevnew-messages.appspot.com') ||
    location.hostname.includes('jumper-emea.com');
};